/**
 * Created by Aleksandr on 06.05.2024
 */

Mission.TYPE_PIGGY_BANK = 106;

Mission.REGISTRATIONS.set(Mission.TYPE_PIGGY_BANK, () => ({
    available: cleverapps.config.availables.PIGGY_BANK_MISSION,
    abTest: PiggyBankMissionLogic.IsNewPiggyBank,
    needsPayments: true,
    canStart: PiggyBankMissionLogic.CanStart,
    name: "PiggyBank",
    view: PiggyBankWindow,
    startWindow: PiggyBankWindow,
    semaphore: Mission.SEMAPHORE_ALWAYS,
    manualFinish: true,
    guideWindow: {
        name: "PiggyBankRulesWindow",
        bundle: bundles.piggybankruleswindow,
        title: "PiggyBankRulesWindow.title"
    },
    sideBarJson: bundles.sidebar.jsons.piggybank_icon_json,
    sideBarProgressBar: {
        prefab: bundles.sidebar.jsons.piggybank_progress_prefab_json,
        income: "hard",
        incomeEffect: cleverapps.styles.GoldMenuBarItem.incEffect
    },
    logic: PiggyBankMissionLogic
}));
